<template>
  <div :class="classes" class="form-input">
    <InputText
      v-bind="$attrs"
      :action="action"
      :value="value"
      @state="updateState"
      @input="relayInput"
      @success="relaySuccess"
      @error="relayError"
      @validation_result="relayValidationResult"
    />
    <div :class="$style.info">
      <img
        :class="{
          [$style.state]: true,
          [$style.blinking]: isBlinking
        }"
        v-if="getStateIcon(state)"
        :title="stateTitle"
        :src="require('@/assets/images/icons/' + getStateIcon(state))"
      />
      <span v-else :class="$style.state">&nbsp;</span>
    </div>
  </div>
</template>

<script>
import { STATES } from '@/config/forms';
import InputText from '@/components/forms/InputText/InputText';

export default {
  components: {
    InputText
  },
  props: {
    value: {},
    large: {
      type: Boolean,
      required: false,
      default: false
    },
    shaded: {
      type: Boolean,
      required: false,
      default: false
    },
    action: {
      type: Function // Parent must pass Function that returns a Function that returns a Promise
    },
    inActionTitle: {
      type: String,
      default: 'Saving...'
    },
    onSuccessTitle: {
      type: String,
      default: 'Saved'
    },
    onErrorTitle: {
      type: String
    },
    withBorder: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      state: STATES.idle,
      errorMessage: ''
    };
  },
  computed: {
    isBlinking() {
      return this.state === STATES.typing;
    },
    classes() {
      const classes = [this.$style.wrapper];

      if (this.large) {
        classes.push(this.$style.large);
      }

      if (this.shaded) {
        classes.push(this.$style.shaded);
      }

      if (this.withBorder) {
        classes.push(this.$style.whiteBackground);
      }

      return classes;
    },
    stateTitle() {
      let titleText = '';

      switch (this.state) {
        case STATES.in_action:
          titleText = this.inActionTitle;
          break;
        case STATES.success:
          titleText = this.onSuccessTitle;
          break;
        case STATES.error:
          if (this.onErrorTitle && this.errorMessage) {
            titleText = this.onErrorTitle;
            titleText += '\n';
            titleText += this.errorMessage;
          }

          if (!this.onErrorTitle && this.errorMessage) {
            titleText += this.errorMessage;
          }

          break;
        default:
          titleText = '';
      }

      return titleText;
    }
  },
  methods: {
    updateState(newState) {
      this.state = newState;
    },
    relayInput(inputValue) {
      this.$emit('input', inputValue);
    },
    relaySuccess(newValue) {
      this.$emit('success', newValue);
    },
    relayError(newValue) {
      this.$emit('error', newValue);
    },
    relayValidationResult(validationResult) {
      this.$emit('validation_result', validationResult);
    },
    getStateIcon(state) {
      if (state === STATES.typing) return 'saving.svg';
      if (state === STATES.in_action) return 'saving.svg';
      if (state === STATES.success) return 'saved.svg';
      if (state === STATES.error) return 'not_saved.svg';

      return undefined;
    }
  }
};
</script>

<style lang="scss" module>
@import '../FormInput/FormInput.scss';
@import './FormInputAutoSave.scss';
</style>
